  <div class="membership-form-container pt-3">
    <!-- Top Header -->
    <div class="form-main-header">
      <div class="title">MEMBERSHIP APPLICATION</div>
      <div class="slanted-box">
        <img src="assets/aze.png" alt="AZ Logo" class="slanted-logo" />
      </div>
    </div>
  
    <form [formGroup]="registrationForm" (ngSubmit)="onSubmit()" novalidate>
  
      <!-- BASIC INFORMATION -->
      <div class="form-section">
        <div class="form-section-header">BASIC INFORMATION</div>
        <div class="form-grid">
          <div>
            <label>Full Name of Workshop Owner <span class="required-asterisk">*</span></label>
            <input type="text" formControlName="ownerName" class="form-control"
              autocomplete="off" [ngClass]="{ 'is-invalid': submitted && f.ownerName.errors }">
            <div *ngIf="submitted && f.ownerName.errors" class="invalid-feedback">
              <div *ngIf="submitted && f.ownerName.errors.required">
                First Name is required
              </div>
            </div>
          </div>
          <div>
            <label>Mobile Number (WhatsApp preferred) <span class="required-asterisk">*</span></label>
            <input type="tel" formControlName="mobileNo" class="form-control" (keypress)="allowOnlyNumbers($event)"
              autocomplete="off" [ngClass]="{ 'is-invalid': submitted && f.mobileNo.errors }">
              <div *ngIf="submitted && f.mobileNo.errors" class="invalid-feedback">
                <div *ngIf="submitted && f.mobileNo.errors.required">
                  Mobile number is required.
                </div>
                 <div *ngIf="f.mobileNo.errors.pattern">
                    Please enter a valid 10‑digit mobile number.
                  </div>
              </div>
          </div>
          <div>
            <label>Alternate Number</label>
            <input type="tel" formControlName="alternateMobileNo" class="form-control"
             (keypress)="allowOnlyNumbers($event)">
          </div>
          <div>
            <label>Email <span class="required-asterisk">*</span></label>
            <input type="email" formControlName="email" class="form-control"
              autocomplete="off" [ngClass]="{ 'is-invalid': submitted && f.email.errors }">
              <div *ngIf="submitted && f.email.errors" class="invalid-feedback">
                <div *ngIf="submitted && f.email.errors.required">
                  Email Address is required
                </div>
                <div *ngIf="submitted && f.email.errors.email">
                  Email Address is not Valid
                </div>
                <div *ngIf="f.email.errors && f.email.errors.apiError">
                  {{ f.email.errors.apiError }}
                </div>
              </div>
          </div>
        </div>
      </div>
  
      <!-- WORKSHOP DETAILS -->
      <div class="form-section">
        <div class="form-section-header">WORKSHOP DETAILS</div>
        <div class="form-grid-responsive">
          
          <div class="form-item">
            <label>Work Shop Legal Name <span class="required-asterisk">*</span></label>
            <input type="text" formControlName="workshopName" class="form-control"
              autocomplete="off" [ngClass]="{ 'is-invalid': submitted && f.workshopName.errors }">
              <div *ngIf="submitted && f.workshopName.errors" class="invalid-feedback">
                <div *ngIf="submitted && f.workshopName.errors.required">
                  Work Shop Legal Name is required.
                </div>
              </div>
          </div>

          <div class="form-item">
            <label>Branch Name <span class="required-asterisk">*</span></label>
            <input type="text" formControlName="branchName" class="form-control"
              autocomplete="off" [ngClass]="{ 'is-invalid': submitted && f.branchName.errors }">
              <div *ngIf="submitted && f.branchName.errors" class="invalid-feedback">
                <div *ngIf="submitted && f.branchName.errors.required">
                  Branch Name is required.
                </div>
              </div>
          </div>
      
          <div class="form-item">
            <label>Workshop Type <span class="required-asterisk">*</span></label>
            <select formControlName="workshopType" class="form-select" 
             [ngClass]="{ 'is-invalid': submitted && f.workshopType.errors }">
              <option value="" disabled>Select type</option>
              <option>Proprietorship</option>
              <option>Partnership</option>
              <option>Pvt Ltd</option>
              <option>LLP</option>
            </select>

            <div *ngIf="submitted && f.workshopType.errors" class="invalid-feedback">
              <div *ngIf="submitted && f.workshopType.errors.required">
                Workshop Type is required
              </div>
            </div>
          </div>
      
          <div class="form-item">
            <label>Year Established <span class="required-asterisk">*</span></label>
            <input type="text"
              id="yearPicker"
              class="form-control"
              bsDatepicker
              [bsConfig]="bsConfig"
              formControlName="establishedYear"
              placeholder="Select Year"
              autocomplete="off"
              [ngClass]="{ 'is-invalid': submitted && f.establishedYear.errors }">
              <div *ngIf="submitted && f.establishedYear.errors" class="invalid-feedback">
                <div *ngIf="submitted && f.establishedYear.errors.required">
                  Year of Established is required.
                </div>
              </div>
          </div>
      
          <div class="form-item">
            <label>GST Number </label>
            <input type="text" formControlName="gstNo" class="form-control" 
              autocomplete="off">
          </div>
      
          <div class="form-item form-item-full">
            <label>Address <span class="required-asterisk">*</span></label>
            <textarea formControlName="workshopAddress" class="form-control" rows="2"
              autocomplete="off" [ngClass]="{ 'is-invalid': submitted && f.workshopAddress.errors }"></textarea>

              <div *ngIf="submitted && f.workshopAddress.errors" class="invalid-feedback">
                <div *ngIf="submitted && f.workshopAddress.errors.required">
                  Workshop Address is required.
                </div>
              </div>
          </div>
      
          <div class="form-item">
            <label>State <span class="required-asterisk">*</span></label>
            <select formControlName="stateId" class="form-select"
             (change)="onStateChange($event)"
              [ngClass]="{ 'is-invalid': submitted && f.stateId.errors }">
              <option value="" disabled selected>Select State</option>
              <option *ngFor="let state of stateList" [value]="state.id">
                {{ state.state }}
              </option>
            </select>

            <div *ngIf="submitted && f.stateId.errors" class="invalid-feedback">
              <div *ngIf="submitted && f.stateId.errors.required">
                State Name is required
              </div>
            </div>

          </div>

          <div class="form-item">
            <label>City <span class="required-asterisk">*</span></label>
            <select formControlName="cityId" class="form-select"
              [ngClass]="{ 'is-invalid': submitted && f.cityId.errors }">
              <option value="" disabled selected>Select City</option>
              <option *ngFor="let city of cityList" [value]="city.id">
                {{ city.city }}
              </option>
            </select>

            <div *ngIf="submitted && f.cityId.errors" class="invalid-feedback">
              <div *ngIf="submitted && f.cityId.errors.required">
                City Name is required
              </div>
            </div>

          </div>
      
          <div class="form-item">
            <label>Pin Code <span class="required-asterisk">*</span></label>
            <input type="text" formControlName="pincode" class="form-control" (keypress)="allowOnlyNumbers($event)"
              autocomplete="off" [ngClass]="{ 'is-invalid': submitted && f.pincode.errors }">
              <div *ngIf="submitted && f.pincode.errors" class="invalid-feedback">
                <div *ngIf="submitted && f.pincode.errors.required">
                  Pincode is required.
                </div>
                <div *ngIf="f.pincode.errors.pattern">
                  Please enter a valid 6‑digit PinCode.
                </div>
              </div>
          </div>
      
          <div class="form-item">
            <label>Landmark</label>
            <input type="text" formControlName="landmark" class="form-control" />
          </div>
      
          <div class="form-item">
            <label class="form-label d-flex align-items-center">
              Google Map Code
              <span class="required-asterisk">*</span>
              <i class="fas fa-info-circle tooltip-icon ms-2 position-relative">
                <span class="tooltip-image">
                  <img src="assets/plus-code-guide.png" alt="How to find Google Plus Code" />
                </span>
              </i>

            </label>
            <input type="text" formControlName="locationCode" class="form-control"
              autocomplete="off" [ngClass]="{ 'is-invalid': submitted && f.locationCode.errors }">
              <div *ngIf="submitted && f.locationCode.errors" class="invalid-feedback">
                <div *ngIf="submitted && f.locationCode.errors.required">
                  Location Code is required.
                </div>
              </div>
          </div>
      
        </div>
      </div>
  
          <!-- SERVICES & INVENTORY -->
    <div class="form-section">
      <div class="form-section-header">SERVICES & INVENTORY</div>
      <div class="form-grid">
        <div class="full">
          <label class="form-label d-block mb-2">Cashless Tie-up Available for Crash Repairs</label>
          <label class="toggle-switch">
            <input type="checkbox" formControlName="crashRepairs" />
            <span class="slider"></span>
            <span class="label-text ms-3">
              {{ registrationForm.get('crashRepairs')?.value ? 'Yes' : 'No' }}
            </span>
          </label>
        </div>

        <div class="full">
          <label class="form-label mb-2">Most Common Vehicle Brands Serviced <span class="required-asterisk">*</span></label>
          <div class="vehicle-brands-grid">
            <label *ngFor="let brand of vehicleBrands" class="brand-check">
              <input type="checkbox"
                     [value]="brand"
                     (change)="onCheckboxChange(brand, 'vehicleServiceBrands', $event)"
                     [checked]="selectedBrands.includes(brand)" />
              <span>{{ brand }}</span>
            </label>
          </div>
            <!-- Error message if none selected -->
            <div *ngIf="submitted && (!f.vehicleServiceBrands.value || f.vehicleServiceBrands.value.length === 0)" class="text-danger mt-1">
              Please select at least one vehicle brand.
            </div>
        </div>

        <div class="row gx-3 full">
          <div class="col-md-4">
            <label>Number of Vehicle Service Bays <span class="required-asterisk">*</span></label>
            <input type="text" formControlName="serviceBays" (keypress)="allowOnlyNumbers($event)"
              autocomplete="off" [ngClass]="{ 'is-invalid': submitted && f.serviceBays.errors }">
              <div *ngIf="submitted && f.serviceBays.errors" class="invalid-feedback">
                <div *ngIf="submitted && f.serviceBays.errors.required">
                  Service Bays is required.
                </div>
              </div>
          </div>
          <div class="col-md-4">
            <label>Monthly Vehicle Inflow (Approx.) <span class="required-asterisk">*</span></label>
            <input type="text" formControlName="vehicleInflow" (keypress)="allowOnlyNumbers($event)"
              autocomplete="off" [ngClass]="{ 'is-invalid': submitted && f.vehicleInflow.errors }">
              <div *ngIf="submitted && f.vehicleInflow.errors" class="invalid-feedback">
                <div *ngIf="submitted && f.vehicleInflow.errors.required">
                  Monthly Vehicle Inflow is required.
                </div>
              </div>
          </div>
          <div class="col-md-4">
            <label>Monthly Parts Purchase Volume <span class="required-asterisk">*</span></label>
            <input type="text" formControlName="partsPurchaseVolume" (keypress)="allowOnlyNumbers($event)"
              autocomplete="off" [ngClass]="{ 'is-invalid': submitted && f.partsPurchaseVolume.errors }">
              <div *ngIf="submitted && f.partsPurchaseVolume.errors" class="invalid-feedback">
                <div *ngIf="submitted && f.partsPurchaseVolume.errors.required">
                  Parts Purchase Volume is required.
                </div>
              </div>
          </div>
        </div>

        <div class="row gx-3 full">
          <div class="col-md-4">
            <label>Number of Mechanics <span class="required-asterisk">*</span></label>
            <input type="text" formControlName="noOfMechanics" (keypress)="allowOnlyNumbers($event)"
              autocomplete="off" [ngClass]="{ 'is-invalid': submitted && f.noOfMechanics.errors }">
              <div *ngIf="submitted && f.noOfMechanics.errors" class="invalid-feedback">
                <div *ngIf="submitted && f.noOfMechanics.errors.required">
                  Number of Mechanics is required.
                </div>
              </div>
          </div>
          <div class="col-md-4">
            <label>Service Manager Name <span class="required-asterisk">*</span></label>
            <input type="text" formControlName="managerName"  (keypress)="allowOnlyText($event)"
              autocomplete="off" [ngClass]="{ 'is-invalid': submitted && f.managerName.errors }">
              <div *ngIf="submitted && f.managerName.errors" class="invalid-feedback">
                <div *ngIf="submitted && f.managerName.errors.required">
                  Manager Name is required.
                </div>
              </div>
          </div>
          <div class="col-md-4">
            <label>Service Manager Contact <span class="required-asterisk">*</span></label>
            <input type="tel" formControlName="managerContact" (keypress)="allowOnlyNumbers($event)"
              autocomplete="off" [ngClass]="{ 'is-invalid': submitted && f.managerContact.errors }">
              <div *ngIf="submitted && f.managerContact.errors" class="invalid-feedback">
                <div *ngIf="submitted && f.managerContact.errors.required">
                  Manager Contact No is required.
                </div>
                 <div *ngIf="f.managerContact.errors.pattern">
                    Please enter a valid 10‑digit mobile number.
                  </div>
              </div>
          </div>
        </div>

        <!-- <div>
          <label>Spare Parts Stock Value <span class="required-asterisk">*</span></label>
          <input type="text" formControlName="partsStockValue" 
            autocomplete="off" [ngClass]="{ 'is-invalid': submitted && f.partsStockValue.errors }">
            <div *ngIf="submitted && f.partsStockValue.errors" class="invalid-feedback">
              <div *ngIf="submitted && f.partsStockValue.errors.required">
                partsStockValue is required.
              </div>
            </div>
        </div> -->
      </div>

      <div class="business-grid">
        <div class="full">
          <label class="form-label mb-2">Nature of Business <span class="required-asterisk">*</span></label>
          <div class="nature-of-business-list">
            <div *ngFor="let type of businessTypes; let i = index" class="form-check">
              <input class="form-check-input"
                    type="checkbox"
                    [value]="type"
                    (change)="onCheckboxChange(type, 'businessNatures', $event)"
                    [checked]="f.businessNatures?.value?.includes(type)"
                    [id]="sanitizeId(type + i)" />
  
              <label class="form-check-label ms-2" [for]="sanitizeId(type + i)">
                {{ type }}
              </label>
  
            </div>
          </div>
        
          <div class="mt-3" *ngIf="f.businessNatures?.value?.includes('Others')">
            <label class="form-label">If Others, specify</label>
            <input type="text" class="form-control" formControlName="natureOfBusinessOthers" />
          </div>

          <div *ngIf="submitted && (!f.businessNatures.value || f.businessNatures.value.length === 0)" class="text-danger mt-1">
            Please select at least one Business Natures.
          </div>
        </div>
      </div>


    </div>

    <div class="form-section">
      <div class="form-section-header">INTEREST IN AZEAPP SERVICES</div>
        <div class="azeapp-expectations-list">
          <label class="form-label mb-2">What are your expectations from AzeApp? <span class="required-asterisk">*</span></label>
      
          <div *ngFor="let expect of expectations" class="form-check">
            <input type="checkbox"
                   class="form-check-input"
                   [value]="expect"
                   (change)="onCheckboxChange(expect, 'expectations', $event)"
                   [checked]="selectedExpectations.includes(expect)"
                   [id]="getExpectationId(expect)" />
      
            <label class="form-check-label ms-2" [for]="getExpectationId(expect)">
              {{ expect }}
            </label>
          </div>

          <div *ngIf="submitted && (!f.expectations.value || f.expectations.value.length === 0)" class="text-danger mt-1">
            Please select at least one Expectations.
          </div>
        
      
        <div class="mt-4">
          <label class="form-label mb-2 d-block">Interested in Training/Recruitment Support?</label>
          <div class="d-flex gap-4 align-items-center">
            <div class="form-check">
              <input class="form-check-input"
                     type="radio"
                     formControlName="trainingRecruitmentSupport"
                     [value]="1"
                     id="trainingYes" />
              <label class="form-check-label" for="trainingYes">Yes</label>
            </div>
      
            <div class="form-check">
              <input class="form-check-input"
                     type="radio"
                     formControlName="trainingRecruitmentSupport"
                     [value]="0"
                     id="trainingNo" />
              <label class="form-check-label" for="trainingNo">No</label>
            </div>
          </div>
        </div>
      </div>
    </div>


    <div class="form-section">
      <div class="form-section-header d-flex justify-content-between align-items-center">
        <span>ADDITIONAL WORKSHOPS</span>
        <button type="button" class="btn btn-outline-primary btn-sm" (click)="addWorkshop()">
          <i class="fas fa-plus-circle me-1"></i> Add Workshop
        </button>
      </div>
    
      <div formArrayName="additionalWorkshops" *ngIf="additionalWorkshops.length > 0">
        <div *ngFor="let group of additionalWorkshops.controls; let i = index" class="workshop-card">

          <div [formGroupName]="i">
            <!-- NOW group is AbstractControl, so cast it to FormGroup via a method -->
            <ng-container *ngIf="getWorkshopGroup(i) as ws">

              <div class="row gx-3">
                <div class="col-md-6 mb-3">
                  <label>Branch Name <span class="required-asterisk">*</span></label>
                  <input formControlName="branchName" class="form-control" type="text" 
                      autocomplete="off" [ngClass]="{ 'is-invalid': submitted && ws.get('branchName')?.errors }">
                      <div *ngIf="submitted && ws.get('branchName')?.errors" class="invalid-feedback">
                        <div *ngIf="ws.get('branchName')?.errors?.required">
                          Branch Name is required.
                        </div>
                      </div>
                </div>
                <div class="col-md-6 mb-3">
                  <label>Manager Name <span class="required-asterisk">*</span></label>
                  <input formControlName="managerName" class="form-control" type="text" 
                   (keypress)="allowOnlyText($event)"
                    autocomplete="off" [ngClass]="{ 'is-invalid': submitted && ws.get('managerName')?.errors }">
                    <div *ngIf="submitted && ws.get('managerName')?.errors" class="invalid-feedback">
                      <div *ngIf="ws.get('managerName')?.errors?.required">
                         Manager Name is required.
                      </div>
                    </div>
                </div>
              </div>

              <div class="row gx-3">
                <div class="col-md-6 mb-3">
                  <label>No. of Mechanics <span class="required-asterisk">*</span></label>
                  <input formControlName="noOfMechanics" class="form-control" type="text" 
                   (keypress)="allowOnlyNumbers($event)"
                    autocomplete="off" [ngClass]="{ 'is-invalid': submitted && ws.get('noOfMechanics')?.errors }">
                    <div *ngIf="submitted && ws.get('noOfMechanics')?.errors" class="invalid-feedback">
                      <div *ngIf="ws.get('noOfMechanics')?.errors?.required">
                        No. of Mechanics is required.
                      </div>
                    </div>
                </div>

                <div class="col-md-6 mb-3">
                  <label>Email <span class="required-asterisk">*</span></label>
                  <input type="email" formControlName="email" class="form-control"
                    autocomplete="off" [ngClass]="{ 'is-invalid': submitted && ws.get('email')?.errors }">
                    <div *ngIf="submitted && ws.get('email')?.errors" class="invalid-feedback">
                      <div *ngIf="ws.get('email')?.errors?.required">
                        Email Address is required
                      </div>
                      <div *ngIf="ws.get('email')?.errors?.email">
                        Email Address is not Valid
                      </div>
                      <div *ngIf="ws.get('email')?.errors && ws.get('email')?.errors?.apiError">
                        {{ ws.get('email')?.errors?.apiError }}
                      </div>
                    </div>
                </div>
                <div class="col-md-6 mb-3">
                  <label>Manager Contact <span class="required-asterisk">*</span></label>
                  <input formControlName="managerContact" class="form-control" type="tel" 
                   (keypress)="allowOnlyNumbers($event)"
                    autocomplete="off" [ngClass]="{ 'is-invalid': submitted && ws.get('managerContact')?.errors }">
                    <div *ngIf="submitted && ws.get('managerContact')?.errors" class="invalid-feedback">
                      <div *ngIf="ws.get('managerContact')?.errors?.required">
                        Manager Contact No is required.
                      </div>
                      <div *ngIf="ws.get('managerContact')?.errors?.pattern">
                        Please enter a valid 10‑digit mobile number.
                      </div>
                    </div>
                </div>
              </div>
        
              <div class="mb-3">
                <label>Workshop Address <span class="required-asterisk">*</span></label>
                <textarea formControlName="workshopAddress" class="form-control" rows="2"
                  autocomplete="off" [ngClass]="{ 'is-invalid': submitted && ws.get('workshopAddress')?.errors }"></textarea>

                
                <div *ngIf="submitted && ws.get('workshopAddress')?.errors" class="invalid-feedback">
                  <div *ngIf="ws.get('workshopAddress')?.errors?.required">
                    Workshop Address is required.
                  </div>
                </div>
              </div>
        


              <div class="row gx-3">
                <div class="col-md-6 mb-3">
                  <label>State <span class="required-asterisk">*</span></label>
                    <select formControlName="stateId" class="form-select"
                     (change)="onStateChanges($event, i)"
                      [ngClass]="{ 'is-invalid': submitted && ws.get('stateId')?.errors }">
                      <option value="" disabled selected>Select State</option>
                      <option *ngFor="let state of stateList" [value]="state.id">
                        {{ state.state }}
                      </option>
                    </select>

                    <div *ngIf="submitted && ws.get('stateId')?.errors" class="invalid-feedback">
                      <div *ngIf="ws.get('stateId')?.errors?.required">
                        State Name is required.
                      </div>
                    </div>
                </div>
                <div class="col-md-6 mb-3">
                  <label>City <span class="required-asterisk">*</span></label>
                    <select formControlName="cityId" class="form-select"
                      [ngClass]="{ 'is-invalid': submitted && ws.get('cityId')?.errors }">
                     <option value="" disabled selected>Select City</option>
                     <option *ngFor="let city of cityLists[i]" [value]="city.id">
                      {{ city.city }}
                    </option>
                    </select>

                    <div *ngIf="submitted && ws.get('cityId')?.errors" class="invalid-feedback">
                      <div *ngIf="ws.get('cityId')?.errors?.required">
                        City Name is required.
                      </div>
                    </div>
                </div>
              </div>
        
              <div class="row gx-3">
                <div class="col-md-6 mb-3">
                  <label>Pin Code <span class="required-asterisk">*</span></label>
                  <input type="text" formControlName="pincode" class="form-control" (keypress)="allowOnlyNumbers($event)"
                    autocomplete="off" [ngClass]="{ 'is-invalid': submitted && ws.get('pincode')?.errors }">
                    <div *ngIf="submitted && ws.get('pincode')?.errors" class="invalid-feedback">
                      <div *ngIf="ws.get('pincode')?.errors?.required">
                        Pincode is required.
                      </div>
                       <div *ngIf="ws.get('pincode')?.errors?.pattern">
                          Please enter a valid 6‑digit PinCode.
                        </div>
                    </div>
                </div>
                <div class="col-md-6 mb-3">
                  <label>Landmark</label>
                  <input type="text" formControlName="landmark" class="form-control">
                </div>
              </div>
        
              <div class="row gx-3">
                <div class="col-md-6 mb-3">
                  <label class="form-label d-flex align-items-center">
                    Google Map Code
                    <i class="fas fa-info-circle tooltip-icon ms-2 position-relative">
                      <span class="tooltip-image">
                        <img src="assets/plus-code-guide.png" alt="How to find Google Plus Code" />
                      </span>
                    </i> <span class="required-asterisk">*</span>
                  </label>
                
                  <input type="text" formControlName="locationCode" class="form-control" 
                    autocomplete="off" [ngClass]="{ 'is-invalid': submitted && ws.get('locationCode')?.errors }">
                    <div *ngIf="submitted && ws.get('locationCode')?.errors" class="invalid-feedback">
                      <div *ngIf="ws.get('locationCode')?.errors?.required">
                        Location Code is required.
                      </div>
                    </div>
                </div>
    
                <div class="col-md-6 mb-3">
                  <label>Monthly Parts Purchase Value <span class="required-asterisk">*</span></label>
                  <input formControlName="partsStockValue" class="form-control" type="text"  (keypress)="allowOnlyNumbers($event)"
                    autocomplete="off" [ngClass]="{ 'is-invalid': submitted && ws.get('partsStockValue')?.errors }">
                    <div *ngIf="submitted && ws.get('partsStockValue')?.errors" class="invalid-feedback">
                      <div *ngIf="ws.get('partsStockValue')?.errors?.required">
                        Monthly Parts Purchase Value is required.
                      </div>
                    </div>
                </div>
              </div>
        
              <!-- Nature of Business -->
              <div class="mb-3">
                <label class="form-label">Nature of Business <span class="required-asterisk">*</span></label>
                <div class="nature-of-business-list">
                  <div *ngFor="let type of businessTypes" class="form-check mb-2">
                    <input class="form-check-input"
                          type="checkbox"
                          [value]="type"
                          (change)="onCheckbox(type, 'businessNatures', $event, ws)"
                          [checked]="ws.get('businessNatures')?.value?.includes(type)"
                          [id]="sanitizeId(type + i)" />
              
                    <label class="form-check-label ms-2" [for]="sanitizeId(type + i)">
                      {{ type }}
                    </label>
                  </div>
                </div>
              
                <div class="mt-2" *ngIf="ws.get('businessNatures')?.value?.includes('Others')">
                  <label>If Others, specify</label>
                  <input type="text" class="form-control" formControlName="natureOfBusinessOthers" />
                </div>

                <div *ngIf="submitted && (!ws.get('businessNatures')?.value || ws.get('businessNatures')?.value.length === 0)" class="text-danger mt-1">
                  Please select at least one Business Natures.
                </div>
              </div>
        
              <!-- Remove Button -->
              <div class="text-end">
                <button type="button" class="btn btn-outline-primary btn-sm me-2" (click)="addWorkshop()">
                  <i class="fas fa-plus-circle me-1"></i> Add Workshop
                </button>
                
                <button type="button" class="btn btn-outline-danger btn-sm" (click)="removeWorkshop(i)">
                  <i class="fas fa-trash-alt me-1"></i> Remove Workshop
                </button>
              </div>


            </ng-container>
          </div>
          
    
        </div>
      </div>
    </div>

  
      
  
    <button type="submit" class="submit-button">
      <i class="fas fa-paper-plane me-2"></i> Submit Application
    </button>
    </form>
  </div>
